module.exports = __webpack_public_path__ + "img/treatments-directory-notices-fr.d3b95cab.jpg";